const LEAGUE_LOGOS = {
  ALL: '/logos/leagues/ALL.svg',
  NFL: '/logos/leagues/NFL.svg',
  NBA: '/logos/leagues/NBA.svg',
  MLB: '/logos/leagues/MLB.png',
  NHL: '/logos/leagues/NHL.png',
  CBB: '/logos/leagues/CBB.svg',
  NCAAB: '/logos/leagues/CBB.svg',
  NCAAM: '/logos/leagues/CBB.svg',
  NCAAW: '/logos/leagues/CBB.svg',
  CFB: '/logos/leagues/CFB.svg',
  NCAAF: '/logos/leagues/CFB.svg',
  SOCCER: '/logos/leagues/SOCCER.svg',
  MMA: '/logos/leagues/MMA.svg',
  UFC: '/logos/leagues/MMA.svg',
  TENNIS: '/logos/leagues/TENNIS.svg',
}

export function getLeagueLogoPath(league) {
  return LEAGUE_LOGOS[String(league || '').toUpperCase()] || null
}
